import React, { useEffect, useState } from "react";
import "./AdminDashboard.css";
import newUser from "../../../components/assets/newUser.svg";
import totalProject from "../../../components/assets/totalProject.svg";
import {
  ADD_DAILY_TASK,
  DELETE_DAILY_TASK,
  GET_DAILY_TASK,
  UPDATE_DAILY_TASK,
} from "../../../components/utils";
import LoadingSpinner from "../../../../src/components/loader/LoadingSpinner";
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from "../../../components/axiosClient";
import { GET_DASHBOARD_COUNT } from "../../../components/utils";
import { useNavigate } from "react-router-dom";
import noDataFound from "../../../components/assets/No data-rafiki 1.svg";
import { Check, Pencil, Trash } from "lucide-react";
import { Modal } from "../../../components/common/Modal";

const showDetailCard = (
  { valueScans, images__state, className__text, cardValue },
  index
) => {
  return cardValue != null ? (
    <div className="main" key={index}>
      <div className="py-4 px-3 admin__received__report__first">
        <div className="grid grid-cols-3">
          <div className="col-span-2">
            <h6 className="font-medium">{valueScans}</h6>
            <span className="admin__dashboard__small text-[28px] font-semibold">
              {cardValue}
            </span>
          </div>
          <div className="col-span-1 flex justify-content-center">
            <div className={className__text}>
              <img
                className="admin__imageOne__style"
                src={images__state}
                alt="download_image"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

const AdminDashboard = () => {
  const [cardData, setCardData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [keysArray, setKeysArray] = useState([]);
  useEffect(() => {
    const keys = Object.keys(cardData);
    setKeysArray(keys);
  }, [cardData]);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [currentTaskIndex, setCurrentTaskIndex] = useState(null);
  const [taskInput, setTaskInput] = useState("");
  const [selectedTask, setSelectedTask] = useState(null);

  const handleAddTask = async () => {
    if (taskInput.trim()) {
      const res = await postRequest(
        ADD_DAILY_TASK,
        { title: taskInput.trim() },
        navigate
      );
      console.log("add daily task", res);

      if (res?.type === 1 && res?.response?.data?.success) {
        // setTasks([...tasks, { title: taskInput }]);
        setTaskInput("");
        setIsAddModalOpen(false);
        await getDailyTask();
      }
    }
  };

  const handleEditTask = async () => {
    if (taskInput.trim() && currentTaskIndex !== null && selectedTask?.id) {
      const res = await patchRequest(
        `${UPDATE_DAILY_TASK}`,
        {
          title: taskInput.trim(),
          task_id: selectedTask?.id,
        },
        navigate
      );

      if (res.type === 1 && res.response.data.success) {
        setTaskInput("");
        setIsEditModalOpen(false);
        setSelectedTask(null);
        await getDailyTask();
      }
    }
  };

  // const handleDeleteTask = () => {
  //   if (currentTaskIndex !== null) {
  //     const updated = tasks.filter((_, i) => i !== currentTaskIndex);
  //     setTasks(updated);
  //     setIsDeleteModalOpen(false);
  //   }
  // };

  const handleDeleteTask = async () => {
    if (!selectedTask) return;
    const res = await deleteRequest(
      `${DELETE_DAILY_TASK}?task_id=${selectedTask?.id}`
    );
    if (res?.type === 1 && res?.response?.data?.success) {
      setIsDeleteModalOpen(false);
      setSelectedTask(null);
      await getDailyTask();
    }
  };

  const [completedTasks, setCompletedTasks] = useState([]);

  const handleToggle = (index) => {
    setCompletedTasks((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const [tasks, setTasks] = useState([]);

  const handleCheckmarkClick = async (task) => {
    if (task?.id) {
      const res = await patchRequest(
        UPDATE_DAILY_TASK,
        { is_completed: !task?.is_completed, task_id: task?.id },
        navigate
      );
      if (res?.type === 1 && res?.response?.data?.success) {
        await getDailyTask();
      }
    }
    // await handleTaskComplete(e.id, e.row.is_completed);
    // await getTaskList();
  };

  const getDailyTask = async () => {
    setLoading(true);
    try {
      const res = await getRequest(
        GET_DAILY_TASK,
        { page: 1, limit: 999999 },
        navigate
      );
      console.log("GET_DAILY_TASK", res);

      setTasks(res?.data?.data?.page_data);
      setLoading(false);
    } catch (error) {}
  };

  const getAllDashboardCard = async () => {
    setLoading(true);
    try {
      const res = await getRequest(GET_DASHBOARD_COUNT, null, navigate);
      setCardData(res.data.data);
      setLoading(false);
    } catch (error) {}
  };

  useEffect(() => {
    getAllDashboardCard();
    getDailyTask();
  }, []);

  const isKeyInArray = (key) => {
    return keysArray.includes(key);
  };

  return  (
    <>
      <div className="admin__main__dash h-full p-4 relative">
        {loading && (<div className="absolute top-0 right-0 bottom-0 left-0 z-10">
          <LoadingSpinner />
        </div>)}
        <div className="h-full overflow-y-auto">
          <div className="h-full mr-1">
            {cardData?.length === 0 ? (
              <div className="no__transcation">
                <img src={noDataFound} alt={noDataFound} loading="lazy" />
              </div>
            ) : (
              <>
                {isKeyInArray("project_list") && (
                  <>
                    <h5 className=" admin__header__dashboard  text-[#292929] text-[20px] mb-2 font-[500]">
                      Project related stats
                    </h5>
                    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3 mb-2">
                      {[
                        {
                          valueScans: "Total Projects",
                          images__state: totalProject,
                          cardValue: cardData?.project_list?.total_project,
                          icon__style: "admin__iconOne__style ",
                          className__text:
                            "admin__image__roundOne  d-flex justify-content-center align-items-center   ",
                        },

                        {
                          valueScans: "Active Projects",
                          images__state: totalProject,
                          cardValue: cardData?.project_list?.running_project,
                          icon__style: "admin__iconOne__style ",
                          className__text:
                            "admin__image__roundOne  d-flex justify-content-center align-items-center   ",
                        },
                        {
                          valueScans: "Complete Projects",
                          images__state: totalProject,
                          cardValue: cardData?.project_list?.complete_project,
                          icon__style: "admin__iconOne__style ",
                          className__text:
                            "admin__image__roundOne  d-flex justify-content-center align-items-center   ",
                        },
                        {
                          valueScans: "Overdue Projects",
                          images__state: totalProject,
                          cardValue: cardData?.project_list?.over_due_project,
                          icon__style: "admin__iconOne__style ",
                          className__text:
                            "admin__image__roundOne  d-flex justify-content-center align-items-center   ",
                        },
                      ]?.map((value, index) => showDetailCard(value, index))}
                    </div>
                  </>
                )}

                {isKeyInArray("employee_list") && (
                  <>
                    <h5 className=" admin__header__dashboard text-[#292929]  text-[20px] mb-2 font-[500]">
                      Employee related stats
                    </h5>
                    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3 mb-2">
                      {[
                        {
                          valueScans: "Total Employee",
                          images__state: newUser,
                          cardValue: cardData?.employee_list?.total_employee,
                          className__text:
                            "admin__image__roundOne d-flex justify-content-center align-items-center",
                        },
                        {
                          valueScans: "Active Employee",
                          images__state: newUser,
                          cardValue: cardData?.employee_list?.active_employee,
                          className__text:
                            "admin__image__roundOne d-flex justify-content-center align-items-center",
                        },
                        {
                          valueScans: "InActive Employee",
                          images__state: newUser,
                          cardValue: cardData?.employee_list?.inactive_employee,
                          className__text:
                            "admin__image__roundOne d-flex justify-content-center align-items-center",
                        },
                        {
                          valueScans: "On Notice Employee",
                          images__state: newUser,
                          cardValue:
                            cardData?.employee_list?.on_termination_employee,
                          className__text:
                            "admin__image__roundOne d-flex justify-content-center align-items-center",
                        },
                      ]?.map((value, index) => showDetailCard(value, index))}
                    </div>
                  </>
                )}
                {/* {
                    isKeyInArray("client_list") && <>
                      <h5 className=" admin__header__dashboard text-[#292929]  text-[20px] mb-2 font-[500]">
                        Client related stats
                      </h5>
                      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3 mb-2">
                        {[
                          {
                            valueScans: "Total Client",
                            images__state: newUser,
                            cardValue: cardData?.client_list?.total_client,
                            className__text:
                              "admin__image__roundOne d-flex justify-content-center align-items-center",
                          },
                        ].map((value, index) => showDetailCard(value, index))}
                      </div>
                    </>
                  } */}
                {/* {
                    isKeyInArray("project_lead_list") && <>
                      <h5 className=" admin__header__dashboard text-[#292929]  text-[20px] mb-2 font-[500]">
                        Project Lead related stats
                      </h5>
                      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3 mb-2">
                        {[
                          {
                            valueScans: "Total Projects Lead",
                            images__state: newUser,
                            cardValue: cardData?.project_lead_list?.total_project_lead,
                            className__text:
                              "admin__image__roundOne d-flex justify-content-center align-items-center",
                          },
                          {
                            valueScans: "Open Project Lead",
                            images__state: newUser,
                            cardValue: cardData?.project_lead_list?.open_project_lead,
                            className__text:
                              "admin__image__roundOne d-flex justify-content-center align-items-center",
                          },
                          {
                            valueScans: "Confirm Sale Project Lead",
                            images__state: newUser,
                            cardValue: cardData?.project_lead_list?.confirm_sale_project_lead,
                            className__text:
                              "admin__image__roundOne d-flex justify-content-center align-items-center",
                          },
                          {
                            valueScans: "Closed Project Lead",
                            images__state: newUser,
                            cardValue: cardData?.project_lead_list?.closed_project_lead,
                            className__text:
                              "admin__image__roundOne d-flex justify-content-center align-items-center",
                          }
                        ].map((value, index) => showDetailCard(value, index))}
                      </div>
                    </>
                  } */}
                {isKeyInArray("candidate_lead_list") && (
                  <>
                    <h5 className=" admin__header__dashboard text-[#292929]  text-[20px] mb-2 font-[500]">
                      Candidate Lead related stats
                    </h5>
                    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3 mb-2">
                      {[
                        {
                          valueScans: "Total Candidate Lead",
                          images__state: newUser,
                          cardValue:
                            cardData?.candidate_lead_list?.total_candidate_lead,
                          className__text:
                            "admin__image__roundOne d-flex justify-content-center align-items-center",
                        },
                        {
                          valueScans: "Open Candidates Lead",
                          images__state: newUser,
                          cardValue:
                            cardData?.candidate_lead_list?.open_candidate_lead,
                          className__text:
                            "admin__image__roundOne d-flex justify-content-center align-items-center",
                        },
                        {
                          valueScans: "Todays Interviews",
                          images__state: newUser,
                          cardValue:
                            cardData?.candidate_lead_list?.todays_interview,
                          className__text:
                            "admin__image__roundOne d-flex justify-content-center align-items-center",
                        },
                        {
                          valueScans: "Upcoming Interviews",
                          images__state: newUser,
                          cardValue:
                            cardData?.candidate_lead_list?.upcoming_interview,
                          className__text:
                            "admin__image__roundOne d-flex justify-content-center align-items-center",
                        },
                      ]?.map((value, index) => showDetailCard(value, index))}
                    </div>
                  </>
                )}
              </>
            )}

            <div className="border border-gray-300 rounded-lg p-3 max-w-6xl bg-white shadow-sm">
              <div className="flex justify-between items-center mb-3">
                <h5 className="admin__header__dashboard text-[#292929] text-[20px] font-[500]">
                  Daily To-Do Tasks
                </h5>
                <button
                  onClick={() => {
                    setTaskInput("");
                    setIsAddModalOpen(true);
                  }}
                  className="bg-[#267072] hover:bg-[#1f5a5a] text-white text-sm px-4 py-2 rounded-md transition duration-200"
                >
                  + Add Daily Task
                </button>
              </div>

              <div className="space-y-3 overflow-y-auto max-h-80 pr-1">
                {tasks.map((task, index) => {
                  const isCompleted = task?.is_completed;
                  return (
                    <div
                      key={index}
                      className="flex flex-col sm:flex-row sm:items-center justify-between bg-gray-50 p-1 rounded-md border border-gray-200 hover:shadow-sm transition-all"
                    >
                      <div className="flex-1 flex items-center gap-2">
                        {/* Checkmark box */}
                        <button
                          onClick={() => handleCheckmarkClick(task)}
                          className={`w-4 h-4 border-2 rounded-full flex items-center justify-center text-xs transition-all
                            ${
                              isCompleted
                                ? "bg-[#267072] border-[#267072]"
                                : "border-gray-400 text-gray-400"
                            }`}
                        >
                          <Check
                            className={`w-4 h-4 transition-all ${
                              isCompleted ? "text-white" : "text-gray-400"
                            }`}
                          />
                        </button>

                        {/* Task Title */}
                        <h6
                          className={`text-base font-semibold m-0 ${
                            isCompleted
                              ? "text-gray-400 line-through"
                              : "text-[#333]"
                          }`}
                        >
                          {task?.title}
                        </h6>
                      </div>

                      <div className=" sm:mt-0 flex items-center gap-4">
                        <div className="flex gap-2">
                          <button
                            onClick={() => {
                              setTaskInput(task?.title);
                              setCurrentTaskIndex(index);
                              setSelectedTask(task);
                              setIsEditModalOpen(true);
                            }}
                            title="Edit"
                          >
                            <Pencil className="w-5 h-5 text-[#267072] hover:text-[#1f5a5a]" />
                          </button>

                          <button
                            onClick={() => {
                              setSelectedTask(task);
                              setCurrentTaskIndex(index);
                              setIsDeleteModalOpen(true);
                            }}
                            title="Delete"
                          >
                            <Trash className="w-5 h-5 text-red-600 hover:text-red-700" />
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        title="Add Daily Task"
      >
        <input
          type="text"
          value={taskInput}
          onChange={(e) => setTaskInput(e.target.value)}
          placeholder="Enter task title"
          className="w-full border rounded p-2 mb-4"
        />
        <button
          onClick={handleAddTask}
          className="bg-[#267072] text-white px-4 py-2 rounded"
        >
          Add Task
        </button>
      </Modal>

      <Modal
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        title="Edit Task"
      >
        <input
          type="text"
          value={taskInput}
          onChange={(e) => setTaskInput(e.target.value)}
          placeholder="Edit task title"
          className="w-full border rounded p-2 mb-4"
        />
        <button
          onClick={handleEditTask}
          className="bg-[#267072] text-white px-4 py-2 rounded"
        >
          Save Changes
        </button>
      </Modal>

      <Modal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        title="Confirm Delete"
      >
        <p className="mb-4">
          Are you sure you want to delete{" "}
          <span className="font-semibold text-[#267072]">
            {selectedTask?.title}
          </span>
          ?
        </p>
        <div className="flex justify-end gap-2">
          <button
            onClick={() => setIsDeleteModalOpen(false)}
            className="text-gray-600 px-3 py-2 rounded border"
          >
            Cancel
          </button>
          <button
            onClick={handleDeleteTask}
            className="bg-red-600 text-white px-3 py-2 rounded"
          >
            Delete
          </button>
        </div>
      </Modal>
    </>
  );
};

export default AdminDashboard;
